import { render, staticRenderFns } from "./InputShareCodeDialog2.vue?vue&type=template&id=68313f2f&scoped=true"
import script from "./InputShareCodeDialog2.vue?vue&type=script&lang=js"
export * from "./InputShareCodeDialog2.vue?vue&type=script&lang=js"
import style0 from "./InputShareCodeDialog2.vue?vue&type=style&index=0&id=68313f2f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68313f2f",
  null
  
)

export default component.exports